// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/nexus/agents/agents.actions.go

export const HEALTH_CHECK = "mondoo.agents.AgentManager.HealthCheck";
